import script from "/app/pages/Users.vue?type=script";
import { render } from "/app/pages/Users.vue?type=template";
script.render = render;
export default script;
